export class SelectFieldsTable {


    certifications = [
        'Certificat1',
        'Certificat2',
        'Certificat3',
        'Certificat4',
    ];
    departmentsCRM = ['Management', 'Marketing', 'Sales', 'Recrutare'];
    // Domains
    domains = [
        {
            name: 'AGRICULTURA',
            subdomains: [
                'Cereale',
                'Plante tehnice',
                'Plante medicinale si aromatice',
                'Cultura bio',
                'Inputuri agricole(Seminte, pesticide, fertilizanti)',
                'Altele'
            ]
        },
        {
            name: 'HORTICULTURA',
            subdomains: [
                'Legumicultura',
                'Pomicultura',
                'Viticultura',
                'Floricultura si amenajari peisagistice',
                'Inputuri horticole(seminte, pesticide, fertilizanti)',
                'Sere, solarii, echipamente',
                'Material saditor',
                'Altele'
            ]
        },
        {
            name: 'ZOOTEHNIE',
            subdomains: [
                'Bovine',
                'Caprine',
                'Ovine',
                'Suine',
                'Pasari',
                'Peste',
                'Cabaline',
                'Animale de companie',
                'Nutritie animala',
                'Reproductie animala',
                'Genetica animala',
                'Altele'
            ]
        },
        {
            name: 'MEDICINA VETERINARA',
            subdomains: [
                'Bovine',
                'Caprine',
                'Ovine',
                'Suine',
                'Pasari',
                'Peste',
                'Cabaline',
                'Animale de companie',
                'Medicamente uz veterinar',
                'Instrumentar laborator si ferme',
                'Analize medicale',
                'Altele'
            ]
        },
        {
            name: 'INDUSTRIA ALIMENTARA',
            subdomains: [
                'Lactate si produse lactate',
                'Carne si mezeluri',
                'Paine si produse panificatie',
                'Bauturi alcoolice si non alcoolice',
                'Oua',
                'Peste',
                'Uleiuri alimentare',
                'Ingrediente alimentare',
                'Uleiuri non alimentare',
                'Procesatori industria alimentara',
                'Producatori industria alimentara',
                'Echipamente  industria alimentara',
                'Retail',
                'Altele'
            ]
        },
        {
            name: 'MASINI si UTILAJE AGRICOLE',
            subdomains: [
                'Masini agricole, horticole, zootehnice',
                'Utilaje agricole, horticole, zootehnice',
                'Piese de schimb',
                'Echipamente',
                'Roboti',
                'Sisteme de irigatii',
                'Solutii transport',
                'Combustibili si uleiuri',
                'Servicii mecanizare',
                'Altele'
            ]
        },
        {
            name: 'DEPOZITARE SI AMBALARE',
            subdomains: [
                'Depozitare',
                'Conditionare',
                'Insacuire',
                'Sortare',
                'Ambalare',
                'Etichetare',
                'Altele'
            ]
        },
        {
            name: 'AGRICULTURA SMART (DIGITALA SI DE PRECIZIE)',
            subdomains: [
                'Soft managementul fermei',
                'Soft managementul culturilor',
                'Soft managementul precipitatiilor',
                'Drone',
                'Statii meteo',
                'Senzori',
                'Gps',
                'Roboti',
                'Altele'
            ]
        },
        {
            name: 'CONSTRUCTIA SI INTRETINEREA FERMEI/FABRICII',
            subdomains: [
                'Proiectare',
                'Materiale de constructii',
                'Echipamente pentru ferma',
                'Sisteme de ventilare',
                'Sisteme de incalzire',
                'Garduri',
                'Sisteme de securitate',
                'Scule, consumabile pentru ferma',
                'Echipamente de protectie',
                'Echipamente pentru curatenie',
                'Produse de igiena si dezinfenctanti',
                'Altele'
            ]
        },
        {
            name: 'MANAGEMENTUL RESTURILOR VEGETALE SI ANIMALE',
            subdomains: [
                'Gestionarea dejectiiilor',
                'Prelucararea resturilor vegetale',
                'Statii de biogaz',
                'Echipamente si instalatii',
                'Altele'
            ]
        },
        {
            name: 'SERVICII',
            subdomains: [
                'Cercetare stiintifica',
                'Testare si multiplicare ',
                'Cercetari de piata agricole',
                'Cercetari de piata zootehnice',
                'Cercetari de piata alimentare',
                'Consultanta  de specialitate',
                'Analize agrochimice sol',
                'Cadastru-topo',
                'Analiza organoleptică',
                'Analize laborator',
                'Servicii de mecanizare',
                'Servicii de depozitare si ambalare',
                'Finantare bancara si nonbancara',
                'Leasing',
                'Fonduri europene',
                'Asigurari',
                'Resurse umane',
                'Financiar-Contabilitate',
                'Audit ',
                'Certificari',
                'Training si dezvoltare profesionala si personala',
                'Protectia mediului',
                'Consultanta fonduri europene'
            ]
        },
        {
            name: 'PISCICULTURA si ACVACULTURA',
            subdomains: [
                'Puiet piscicol',
                'Nutritie piscicola',
                'Echipamente piscicole',
                'Altele'
            ]
        },
        {
            name: 'APICULTURA',
            subdomains: [
                'Familii de albine',
                'Stupii, accesorii apicole',
                'Altele'
            ]
        },
        {
            name: 'SILVICULTURA',
            subdomains: [
                'Infiintarea plantatiilor',
                'Intretinerea plantatiilor',
                'Altele'
            ]
        },
        {
            name: 'ALTELE',
            subdomains: [
                'Altele',
            ]
        },
    ]

    // Departments
    departments = [
        'Abatorizare',
        'Achizitii',
        'Achizitii animale',
        'Achizitii cereale si plante tehnice',
        'Achizitii legume',
        'Administrare ferme',
        'Administratia statului',
        'Admistrativ, servicii suport',
        'Agricultura digitala (hardware si software)',
        'Asigurarea calitatii',
        'Asigurari',
        'Asigurari agricole',
        'Audit',
        'Audit calitate',
        'Audit contabil',
        'Automatizari',
        'Banci / Servicii financiare',
        'Biochimie',
        'Bioenergie',
        'Biogaz',
        'Biolog',
        'Biosecuritatea produselor alimentare',
        'Biotehnolog',
        'Cadastru-Imobiliare',
        'Call center',
        'Cercetare de piață',
        'Cercetare-dezvoltare',
        'Certificare calitate',
        'Certificare standarde servicii',
        'Chimie',
        'Clinici veterinare',
        'Comert / Retail',
        'Constructii',
        'Consultanta de specialitate',
        'Contabilitate',
        'Controlul calității produselor agroalimentare',
        'Controlul si expertiza produselor agroalimentare',
        'Credit control',
        'Cultivarea plantelor',
        'Curatenie ',
        'Depozitare-Pastrare-Conditionare',
        'Echipamente',
        'Economie agricola',
        'Educatie, training',
        'Energie eoliana',
        'Energie solara',
        'Enologie',
        'Expozitii agro-alimentare',
        'Fabricarea mezelurilor',
        'Financiar-contabil',
        'Finantari bancare si non bancare',
        'Genetica si ameliorarea animalelor',
        'Genetică şi ameliorarea plantelor',
        'Geodezie',
        'Gestiune',
        'Grafica-Webdesign -DTP',
        'Hidrologie',
        'Imbunatatiri funciare',
        'Import – export',
        'Inginerie',
        'Internet / e-Commerce',
        'IT Hardware',
        'IT Software',
        'Juridic',
        'Jurnalism',
        'Laborator, analize',
        'Lemn si produse derivate',
        'Logistica',
        'Macelarie',
        'Management',
        'Marketing',
        'Medicina veterinara',
        'Merchandising / Promoteri',
        'Nutritia plantelor',
        'Nutritia si alimentatia animalelor',
        'Office / Back-office',
        'ONG / Voluntariat',
        'Pedologie',
        'Piscicultura si acvacultura',
        'Procesare',
        'Productie alimentara',
        'Productie horticola',
        'Productie vegetala',
        'Productie zootehnica',
        'Produse de curatenie, dezinfectie',
        'Produse petrochimice, energie verde',
        'Proiectare civila / industriala',
        'Proiectare sisteme de irigatii',
        'Protectia mediului',
        'Protectia muncii',
        'Protectia plantelor',
        'Publicitate',
        'Relatii clienti',
        'Relatii publice',
        'Reproductie animala',
        'Resurse Umane',
        'Sanatate si securitate in munca',
        'Secretariat',
        'Service / Reparatii',
        'Servicii financiare',
        'Servicii mecanizare',
        'Software agricol',
        'Somelier',
        'Statistica ',
        'Tehnologia cultivarii arborilor si arbustilor fructiferi',
        'Tehnologie alimentara ',
        'Tehnologii  în industria alimentară',
        'Tehnologii de crestere a animalelor',
        'Tehnologii de procesare a produselor agroalimentare',
        'Telecomunicatii',
        'Telemarketing',
        'Telesales',
        'Tipografii / Edituri',
        'Topografie',
        'Trading',
        'Transport / Distributie',
        'Turism-Agroturism',
        'Utilaje si service industrie alimentara',
        'Vanzari',
        'Vanzari produse fertilizarea plantelor',
        'Vanzari produse protectia plantelor',
        'Vanzari seminte',
        'Vanzari-Distributie',
        'Viticultura',
        'Altele',
    ]

    // Languages
    languages = [
        'Arabă',
        'Bulgară',
        'Cehă',
        'Chineză',
        'Croată',
        'Daneză',
        'Ebraică',
        'Engleză',
        'Finlandeză',
        'Franceză',
        'Germană',
        'Greacă',
        'Italiană',
        'Japoneză',
        'Maghiară',
        'Norvegiană',
        'Olandeză',
        'Persană',
        'Poloneză',
        'Portugheză',
        'Română',
        'Rusă',
        'Sarbă',
        'Slovacă',
        'Slovenă',
        'Spaniolă',
        'Suedeză',
        'Turcă',
        'Ucraineană',
    ]

    // Years
    years = [
        '1',
        '2',
        '3',
        '4',
        '5'
    ]

    // Yes or No
    yesOrNoAnswer = ['Da', 'Nu']
}
